/**
* Recursive search up the DOM
* @param {HTMLElement} node
* @param {string} name To search in the cj dataset
* @returns {(HTMLElement|Boolean)} Node or false
*/
const findElement = (node, name) => {
	const thisIsItChief = node.dataset && node.dataset.cj === name;
	if (thisIsItChief) return node;
	const parent = node.parentElement;
	if (parent) return findElement(parent, name);
	return false;
};

export default findElement;
